module.exports = __webpack_public_path__ + "img/build-in-2020-4.efd2d2b3.jpg";